module.exports = __webpack_public_path__ + "c_static/img/no_data.38e2f24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/no_data.jpg
// module id = oYJw
// module chunks = 33